import pedidoVentaService from '../services/pedidoVentaService';
import type { VentaPendienteMaster } from '../services/ventasSeguimientoService';
import {
  estadoDesdePedido,
  normalizeEstadoPedidoMaster,
} from './pedidoVentaEstados';

/** Resuelve el estado: pedido origen (fuente de verdad) y luego el endpoint de pendientes. */
export function resolverEstadoPendientePedido(
  pendiente: VentaPendienteMaster,
  pedido?: Parameters<typeof estadoDesdePedido>[0] | null,
): string {
  const desdePedido = pedido ? estadoDesdePedido(pedido) : undefined;
  return normalizeEstadoPedidoMaster(desdePedido ?? pendiente.estadoMaster);
}

/** Completa estadoMaster desde el pedido origen (fuente de verdad). */
export async function enrichPendientesConEstadoPedido(
  rows: VentaPendienteMaster[],
): Promise<VentaPendienteMaster[]> {
  if (rows.length === 0) return rows;

  const formularios = Array.from(
    new Set(rows.map((p) => p.nroFormularioMaster).filter((n) => n > 0)),
  );
  const pedidosPorFormulario = new Map<number, Awaited<ReturnType<typeof pedidoVentaService.getPedidoVenta>>>();

  await Promise.all(
    formularios.map(async (nroFormulario) => {
      try {
        const pedido = await pedidoVentaService.getPedidoVenta(nroFormulario, { sinCache: true });
        pedidosPorFormulario.set(nroFormulario, pedido);
      } catch {
        /* pedido no disponible */
      }
    }),
  );

  return rows.map((p) => ({
    ...p,
    estadoMaster: resolverEstadoPendientePedido(
      p,
      pedidosPorFormulario.get(p.nroFormularioMaster),
    ),
  }));
}
